import React, { ReactElement } from 'react';
import './src/styles/index.less';
import Template from './src/components/Template';
import { PageProps } from 'gatsby';

export const onInitialClientRender = () => {
    setTimeout(() => {
        const preloader = document.getElementById('preloader');
        if (preloader) {
            preloader.style.display = 'none';
        }
    }, 3000);
};

export const wrapPageElement = ({
    element,
    props
}: {
    element: ReactElement;
    props: PageProps;
}) => {
    return <Template {...props}>{element}</Template>;
};
